var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupIconHelpDrawer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.16668 11.1916C8.16668 11.11 8.19779 11.0296 8.26001 10.9674L13.2274 5.99998L8.26001 1.03257C8.13557 0.90813 8.13557 0.707204 8.26001 0.584056C8.38446 0.459612 8.58538 0.459612 8.70853 0.584056L13.9002 5.77572C14.0246 5.90017 14.0246 6.10109 13.9002 6.22424L8.70853 11.4159C8.58409 11.5404 8.38316 11.5404 8.26001 11.4159C8.19779 11.3537 8.16668 11.2733 8.16668 11.1916Z",
    fill: "#091AB9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0.00649345 5.99997C0.00649345 5.82497 0.149086 5.68237 0.324086 5.68237L13.6759 5.68237C13.8509 5.68237 13.9935 5.82497 13.9935 5.99997C13.9935 6.17497 13.8509 6.31756 13.6759 6.31756L0.324086 6.31756C0.149086 6.31756 0.00649345 6.17497 0.00649345 5.99997Z",
    fill: "#091AB9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupIconHelpDrawer);
export default __webpack_public_path__ + "static/media/GroupIconHelpDrawer.a8ed72ca6371a90fb5b39abd2fcbd1d0.svg";
export { ForwardRef as ReactComponent };